import React from "react";
import Link from "next/link";
import twitter from "../../assets/images/twitter.png";
import tikTok from "../../assets/images/tikTok.png";
import broadcast from "../../assets/images/broadcast.png";
const SocialMediaLinks = () => {
  return (
    <>
      {" "}
      <div>
        <Link
          href="/betcast"
          className="color-orange"
          style={{ padding: ".33rem .5rem", border: "1px solid", borderRadius: "15px" }}
        >
          BetCast
        </Link>
      </div>
      <div style={{ width: "34px", height: "34px" }}>
        <Link href="https://twitter.com/shotqualitybets?lang=en" target={"blank"}>
          <img src={twitter.src} className="SocialIconImg" alt="Twitter" />
        </Link>
      </div>
      <div style={{ width: "34px", height: "34px" }}>
        <Link href="https://www.tiktok.com/@shotqualitybets" target={"blank"}>
          <img src={tikTok.src} className="SocialIconImg" alt="TikTok" />
        </Link>
      </div>
      <div style={{ width: "34px", height: "34px" }}>
        <Link href="https://podcasts.apple.com/us/podcast/shotquality-bets/id1657213908" target={"blank"}>
          <img src={broadcast.src} className="SocialIconImg" alt="Apple Podcast" />
        </Link>
      </div>
    </>
  );
};

export default SocialMediaLinks;
